<template>
    <v-card width="300">
        <v-toolbar dark dense flat color="primary lighten-1">
            <v-toolbar-title>Filter</v-toolbar-title>
        </v-toolbar>

        <v-container>
            <v-select label="Apps"
                      :items="apps || []"
                      :value="selectedApps"
                      @change="emitFilterChanged('apps', $event)"
                      item-text="name"
                      item-value="id"
                      multiple chips deletable-chips/>
            <v-select label="Sprachen"
                      :items="languages"
                      :value="selectedLanguage"
                      @change="emitFilterChanged('language', $event)"
                      item-text="name"
                      item-value="id"
                      chips/>
            <v-select label="Typen"
                      :items="types"
                      :value="selectedTypes"
                      @change="emitFilterChanged('types', $event)"
                      item-text="name"
                      item-value="id"
                      multiple>
                <template v-slot:selection="data">
                    <v-flex xs2>
                        <v-avatar size="25px">
                            <v-icon>{{ data.item.icon }}</v-icon>
                        </v-avatar>
                    </v-flex>
                </template>
                <template v-slot:item="data">
                    <v-list-item-avatar>
                        <v-icon>{{ data.item.icon }}</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title v-html="data.item.name"></v-list-item-title>
                    </v-list-item-content>
                </template>
            </v-select>
        </v-container>

    </v-card>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import notificationTypes from "../../utils/notificationTypes";

export default {
    name: "FilterBox",
    props: {
        filters: {
            type: Object,
            default: () => {
                return {
                    apps: [],
                    language: [],
                    types: [],
                }
            }
        },
    },
    model: {
        prop: 'filters',
        event: 'change'
    },
    mounted() {
        if (!this.appsLoaded) {
            this.loadApps()
                .then(apps => {
                    console.log("update selected apps", apps)
                    this.selectedApps = apps.map(app => app.id);
                });
        }
    },
    data() {
        return {
            languages: [
                {id: 'de', name: 'Deutsch'},
                {id: 'en', name: 'Englisch'},
            ],
            types: [
                {id: 'info', name: 'Info', icon: notificationTypes['info']},
                {id: 'warning', name: 'Warnung', icon: notificationTypes['warning']},
            ],
            selectedApps: ['bisecur', 'bluesecur', 'bluecontrol'],
            selectedLanguage: 'de',
            selectedTypes: ['info', 'warning'],
        };
    },
    computed: {
        ...mapState({
            apps: state => state.app.apps,
        }),
        ...mapGetters('app', [
            'appsLoaded'
        ]),
    },
    methods: {
        ...mapActions('app', [
            'loadApps'
        ]),
        emitFilterChanged(property, value) {
            this.$emit('change', Object.assign({
                apps: this.selectedApps,
                language: this.selectedLanguage,
                types: this.selectedTypes
            }, {[property]: value}));
        }
    }
}
</script>

<style scoped>

</style>
